<template>
    <div :class="primitiveBaseClasses">
        <label :class="this.bold ? 'amf-input-label-bold' : 'amf-input-label'">{{label}}</label>
        <div class="text">{{flattenedValue}}</div>
    </div>
</template>

<script>
import primitiveMixin from './primitive-mixin'
export default {
    mixins: [primitiveMixin],
    props: {
        label: String,
        value: {},
        title: {type:String, required: false},
        disabled: true,
        bold: {
            type: Boolean,
            default: false,
            required: false
        },
    },
    computed: {
        flattenedValue(){
            if(Array.isArray(this.value)){
                return this.value.join(",");
            }
            return this.value;
        }
    }
}
</script>

<style lang="scss" scoped>
.text{
    display: block;
    border: none;
    width: 100%;
    height: 2.16rem;
    font-size: 0.9rem;
    padding: 0.375rem 0 0.375rem 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/framework/primitives/AmfInfo.vue